import { useEffect, useState } from 'react';

import type { Nullish } from '~/types/generics';

const useImageLoaded = (src: Nullish<string>) => {
  const [loadedSrc, setLoadedSrc] = useState<Nullish<string>>(null);

  useEffect(() => {
    if (!src) {
      return;
    }

    const handleLoad = () => {
      setLoadedSrc(src);
    };

    const img = new Image();
    img.addEventListener('load', handleLoad);
    img.src = src;

    return () => {
      img.removeEventListener('load', handleLoad);
    };
  }, [src]);

  return !!src && loadedSrc === src;
};

export default useImageLoaded;
